import { useEffect, useState } from "react"
import { SearchBar } from "../../components/SearchBar"
import { MobileSubscription } from "../../interface/MobileSubscription"
import { BillingApi } from "../../api/BillingApi"
import { SubscriptionsList } from "./SubscriptionsList"
import Grid from "@mui/material/Grid"
import { LottieLoading } from "../../components/placeholder/LottieLoading"
import { SubscriptionManageModalAndroid } from "./SubscriptionManageModalAndroid"
import { SubscriptionManageModalApple } from "./SubscriptionManageModalApple"




export const SubscriptionsContainer = () => {


    const [ query, setQuery ] = useState("")
    const [ subscriptions, setSubscriptions ] = useState<MobileSubscription[]>([])
    const [ snack , setSnack ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ showManageModal, setShowManageModal ] = useState<MobileSubscription | undefined>()

    const useFilteredSubscriptions = () => {
        if(!query) return subscriptions

        return subscriptions?.filter(s => {
            if(s.email?.toLowerCase().includes(query.toLowerCase())) return true

        })
    }

    useEffect(() => {

        getAllUserSubscriptions(true)
        
    }, [])

    const getAllUserSubscriptions = async (progress: boolean) => {

        if(progress) setLoading(true)
        try
        {   
            const response = await new BillingApi().getMobileSubscriptions()
            setSubscriptions(response || [])
        }
        catch(error)
        {
            console.error(error)
        }

       if(progress) setLoading(false)

    }

    const filtered = useFilteredSubscriptions()

    return (
        <div style={styles.container}>

            <Grid container direction="column" spacing={3}>
                <Grid item xs={12}>
                    <SearchBar placeholder="Search subscriptions" setQuery={setQuery} />
                </Grid>

                <Grid item>
                    { loading && <LottieLoading animation={require("../../animations/person-lottie.json")} height={150} width={150} loop text="Getting Subscriptions" containerHeight="80vh" />}
                    { !loading && subscriptions?.length === 0 && <LottieLoading animation={require("../../animations/log-lottie.json")} height={150} width={150} loop={false} text="No user subscriptions" containerHeight="80vh" />}

                </Grid>

                { !loading && subscriptions?.length > 0 && <Grid item>
                    <SubscriptionsList subscriptions={filtered} onEdit={setShowManageModal}/>
                </Grid> }
                
            </Grid>

            { showManageModal && showManageModal?.androidPurchaseToken && <SubscriptionManageModalAndroid onRefresh={() => getAllUserSubscriptions(false)} open subscriptionListItem={showManageModal} onClose={() => setShowManageModal(undefined)} />}
            { showManageModal && showManageModal?.IOSreceipt && <SubscriptionManageModalApple onRefresh={() => getAllUserSubscriptions(false)} open subscriptionListItem={showManageModal} onClose={() => setShowManageModal(undefined)} />}


        </div>
    )
}

const styles = {
    container: {
        height: "93vh"
    }
}